import { AuthenticationError } from './AuthenticationError';

export class BadSubscriptionKeyError extends AuthenticationError {
	constructor(code: string, message: string, cause?: Error) {
		super(code, message, cause);
		this.code = code ?? 'ERROR_BAD_SUBSCRIPTION_KEY';
	}
}
